import React, { useState, useEffect } from 'react';

import { Tooltip, Flex, useColorModeValue, useToast } from '@chakra-ui/react';
import { CiRead } from 'react-icons/ci';
import { FiSend } from 'react-icons/fi';
import { FaAngellist } from 'react-icons/fa';
import { BsReply } from 'react-icons/bs';
import { AiOutlineDelete } from 'react-icons/ai';
import { RxUpdate } from 'react-icons/rx';

import { BiLogoLinkedinSquare } from 'react-icons/bi';
import { BsTwitterX } from 'react-icons/bs';
import { FiInstagram } from 'react-icons/fi';
import { BiLogoFacebookCircle } from 'react-icons/bi';
import { FiPhoneCall } from 'react-icons/fi';
import { FiMoreHorizontal } from 'react-icons/fi';

import ProspectSkeletons from '../../Skeletons/ProspectSkeletons';

import Table from '..';

import axios from '../../../utils/axios';

import { useSelector, useDispatch } from 'react-redux';
import { getProspects } from '../../../redux/actions/prospectActions';

import { updateEdit, delEdit } from '../../../redux/actions/utilActions';

function ProspectTable({ onOpen, delOpen, addOnOpen, onBulkOpen }) {
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [copyEmail, setCopyEmail] = useState('');

  const toast = useToast();

  // const prospectsData = async () => {
  //   try {
  //     const res = await axios.get("/api/emails/all_prospects");
  //     setData(res.data);
  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    //prospectsData();
    // dispatch(getProspects());
  }, []);

  const prospects = useSelector((state) => state.prospects.prospects);
  const totalProspects = useSelector((state) => state.prospects.totalProspects);

  useEffect(() => {
    setData(prospects);
    setLoading(false);
  }, [prospects]);

  const trueColor = 'orange';
  const falseColor = useColorModeValue('black', 'white');

  if (loading) {
    return <ProspectSkeletons />;
  }

  const handleCopy = (text) => {
    // Copy the text to the clipboard
    navigator.clipboard.writeText(text);
    toast({
      title: 'Copied',
      status: 'success',
      duration: 2000,
      isClosable: true,
      position: 'bottom-left',
    });
  };

  const isRepliedChange = async (_id, isReplied) => {
    try {
      await axios.put('/api/emails/is_replied_manually', {
        _id,
        isReplied: !isReplied,
      });
      const findProspect = data.map((el) =>
        el._id == _id ? { ...el, isReplied: !isReplied } : el
      );

      toast({
        title: `Marked as ${isReplied ? 'not replied' : 'replied'}`,
        status: 'success',
        duration: 2000,
        isClosable: true,
        position: 'bottom-left',
      });

      setData(findProspect);
    } catch (error) {
      console.log(error);
    }
  };

  const isInterestedChange = async (_id, isInterested) => {
    try {
      await axios.put('/api/emails/is_interested', {
        _id,
        isInterested: !isInterested,
      });
      const findProspect = data.map((el) =>
        el._id == _id ? { ...el, isInterested: !isInterested } : el
      );

      toast({
        title: `Marked as ${isInterested ? 'not interested' : 'interested'}`,
        status: 'success',
        duration: 2000,
        isClosable: true,
        position: 'bottom-left',
      });

      setData(findProspect);
    } catch (error) {
      console.log(error);
    }
  };

  const isConnectionChange = async (_id, status, type) => {
    try {
      await axios.put('/api/emails/connections', {
        _id,
        status: !status,
        type: type,
      });
      const findProspect = data.map((el) =>
        el._id == _id
          ? { ...el, connections: { ...el.connections, [type]: !status } }
          : el
      );

      toast({
        // title: `Marked as ${status ? "not interested" : "interested"}`,
        title: `Marked as "${type}" ${status ? 'Not connected' : 'connected'}`,
        status: 'success',
        duration: 2000,
        isClosable: true,
        position: 'bottom-left',
      });

      setData(findProspect);
    } catch (error) {
      console.log(error);
    }
  };

  const NameCell = ({ value, row }) => {
    return (
      <Tooltip
        hasArrow
        label={`${row.original.firstName} ${row.original.lastName}`}
        aria-label="A tooltip"
      >
        <a
          href={`${row.original.url && row.original.url}`}
          target={row.original.url && '_blank'}
        >
          <span>{value ? value.replace(/(.{15})..+/, '$1…') : 'N/A'}</span>
        </a>
      </Tooltip>
    );
  };

  const EmailCell = ({ value, row }) => {
    return (
      <Tooltip hasArrow label={row.original.email} aria-label="A tooltip">
        <span onClick={() => handleCopy(value)}>
          {value ? value.replace(/(.{15})..+/, '$1…') : 'N/A'}
        </span>
      </Tooltip>
    );
  };

  const PhoneCell = ({ value, row }) => {
    return (
      <Tooltip hasArrow label={row.original.phone} aria-label="A tooltip">
        <span>
          <a href={`tel:${value}`} aria-disabled="true">
            {value ? value.replace(/(.{15})..+/, '$1…') : 'N/A'}
          </a>
        </span>
      </Tooltip>
    );
  };

  const domainCell = ({ value, row }) => {
    return (
      <Tooltip
        hasArrow
        label={
          row.original.company_domain
            ? row.original.company_domain
            : value
            ? value
            : ''
        }
        aria-label="A tooltip"
      >
        {/* <span>{value ? value.replace(/(.{10})..+/, "$1…") : "N/A"}</span> */}
        <span>
          {row.original.company_domain
            ? row.original.company_domain.replace(/(.{15})..+/, '$1…')
            : value
            ? value.replace(/(.{10})..+/, '$1…')
            : 'N/A'}
        </span>
      </Tooltip>
    );
  };

  const companyCell = ({ value, row }) => {
    return (
      <Tooltip
        hasArrow
        label={
          row.original.company_name
            ? row.original.company_name
            : value
            ? value
            : 'N/A'
        }
        aria-label="A tooltip"
      >
        {/* <span>{value.replace(/(.{15})..+/, "$1…")}</span> */}
        {row.original.company_name
          ? row.original.company_name.replace(/(.{15})..+/, '$1…')
          : value
          ? value.replace(/(.{10})..+/, '$1…')
          : 'N/A'}
      </Tooltip>
    );
  };

  const designationCell = ({ value, row }) => {
    return (
      <Tooltip hasArrow label={row.original.designation} aria-label="A tooltip">
        <span>{value ? value.replace(/(.{15})..+/, '$1…') : 'N/A'}</span>
      </Tooltip>
    );
  };

  const addressCell = ({ value, row }) => {
    return (
      <Tooltip hasArrow label={row.original.address} aria-label="A tooltip">
        <span>{value ? value.replace(/(.{15})..+/, '$1…') : 'N/A'}</span>
      </Tooltip>
    );
  };

  const statusesCell = ({ value, row }) => {
    const {
      _id,
      email,
      sent,
      isRead,
      isReplied,
      isInterested,
      messages,
      connections,
    } = row.original;

    const isSent = messages.find((message) => message.isSent == true);

    const delivered = messages.filter((message) => message.isSent == true);

    const isViewed = messages.find((message) => message.isRead == true);
    const viewed = messages.filter((message) => message.isRead == true);

    return (
      <Flex alignItems="center">
        <Tooltip
          hasArrow
          label={
            connections.linkedin ? 'Connection Sent' : 'Connection not sent'
          }
          aria-label="A tooltip"
          bg={connections.linkedin ? trueColor : falseColor}
        >
          <span
            style={{ marginRight: 5 }}
            onClick={() => {
              isConnectionChange(_id, connections.linkedin, 'linkedin');
            }}
          >
            <BiLogoLinkedinSquare
              size={20}
              color={connections.linkedin ? trueColor : falseColor}
            />
          </span>
        </Tooltip>
        <Tooltip
          hasArrow
          label={
            connections.instagram
              ? 'Instagram Approaching'
              : 'Instagram not approached'
          }
          aria-label="A tooltip"
          bg={connections.instagram ? trueColor : falseColor}
        >
          <span
            style={{ marginRight: 5 }}
            onClick={() => {
              isConnectionChange(_id, connections.instagram, 'instagram');
            }}
          >
            <FiInstagram
              size={18}
              color={connections.instagram ? trueColor : falseColor}
            />
          </span>
        </Tooltip>
        <Tooltip
          hasArrow
          label={connections.twitterX ? 'X Approaching' : 'X not approached'}
          aria-label="A tooltip"
          bg={connections.twitterX ? trueColor : falseColor}
        >
          <span
            style={{ marginRight: 5 }}
            onClick={() => {
              isConnectionChange(_id, connections.twitterX, 'twitterX');
            }}
          >
            <BsTwitterX
              size={15}
              color={connections.twitterX ? trueColor : falseColor}
            />
          </span>
        </Tooltip>
        <Tooltip
          hasArrow
          label={
            connections.facebook
              ? 'Facebook Approaching'
              : 'Facebook not approached'
          }
          aria-label="A tooltip"
          bg={connections.facebook ? trueColor : falseColor}
        >
          <span
            style={{ marginRight: 5 }}
            onClick={() => {
              isConnectionChange(_id, connections.facebook, 'facebook');
            }}
          >
            <BiLogoFacebookCircle
              size={20}
              color={connections.facebook ? trueColor : falseColor}
            />
          </span>
        </Tooltip>

        <Tooltip
          hasArrow
          label={connections.call ? 'Call Approaching' : 'Call not approached'}
          aria-label="A tooltip"
          bg={connections.call ? trueColor : falseColor}
        >
          <span
            style={{ marginRight: 5 }}
            onClick={() => {
              isConnectionChange(_id, connections.call, 'call');
            }}
          >
            <FiPhoneCall
              size={15}
              color={connections.call ? trueColor : falseColor}
            />
          </span>
        </Tooltip>

        <Tooltip
          hasArrow
          label={`${delivered.length} of ${messages.length} delivered`}
          aria-label="A tooltip"
          bg={sent ? trueColor : falseColor}
        >
          <span>
            <FiSend size={15} color={isSent ? trueColor : falseColor} />
          </span>
        </Tooltip>
        <Tooltip
          hasArrow
          label={`${viewed.length} of ${messages.length} viewed`}
          aria-label="A tooltip"
          bg={isRead ? trueColor : falseColor}
        >
          <span style={{ width: 'fit-content' }}>
            <CiRead size={19} color={isViewed ? trueColor : falseColor} />
          </span>
        </Tooltip>
        <Tooltip
          hasArrow
          label={isReplied ? 'Replied' : 'Not Replied'}
          aria-label="A tooltip"
          bg={isReplied ? trueColor : falseColor}
        >
          <span
            style={{ width: 'fit-content' }}
            onClick={() => {
              isRepliedChange(_id, isReplied);
            }}
          >
            <BsReply size={19} color={isReplied ? trueColor : falseColor} />
          </span>
        </Tooltip>
        <Tooltip
          hasArrow
          label={isInterested ? `Interested` : `Not Interested`}
          aria-label="A tooltip"
          bg={isInterested ? trueColor : falseColor}
        >
          <span
            style={{ width: 'fit-content' }}
            onClick={() => {
              isInterestedChange(_id, isInterested);
            }}
          >
            <FaAngellist
              size={15}
              color={isInterested ? trueColor : falseColor}
            />
          </span>
        </Tooltip>
      </Flex>
    );
  };

  const ActionsCell = ({ value, row }) => {
    const { _id, email } = row.original;

    return (
      <Flex alignItems="center">
        <Tooltip hasArrow label={`Update Prospect`} aria-label="A tooltip">
          <span
            style={{ width: 'fit-content', marginRight: 5 }}
            onClick={() => {
              dispatch(updateEdit(_id));
              onOpen();
              // console.log(_id);
            }}
          >
            <RxUpdate size={15} />
          </span>
        </Tooltip>
        <Tooltip hasArrow label={`Delete Prospect`} aria-label="A tooltip">
          <span
            style={{ width: 'fit-content' }}
            onClick={() => {
              dispatch(delEdit(email));
              delOpen();
            }}
          >
            <AiOutlineDelete size={15} />
          </span>
        </Tooltip>
      </Flex>
    );
  };

  const columns = [
    {
      Header: 'Name',
      accessor: 'firstName',
      Cell: NameCell,
      width: 10,
    },
    {
      Header: 'Statuses',
      accessor: 'statuses',
      Cell: statusesCell,
      // width: 30,
    },
    {
      Header: 'email',
      accessor: 'email',
      // maxWidth: 50,
      // minWidth: 50,
      // width: 50,
      Cell: EmailCell,
    },
    {
      Header: 'Contact',
      accessor: 'phone',
      Cell: PhoneCell,
    },
    {
      Header: 'Domain',
      accessor: 'domain',
      Cell: domainCell,
    },

    {
      Header: 'Company',
      accessor: 'company',
      Cell: companyCell,
    },
    {
      Header: 'Designation',
      accessor: 'designation',
      Cell: designationCell,
    },
    {
      Header: 'Address',
      accessor: 'address',
      Cell: addressCell,
    },
    // {
    //   Header: "Statuses",
    //   accessor: "statuses",
    //   Cell: statusesCell,
    // },
    {
      Header: 'Actions',
      accessor: 'actions',
      Cell: ActionsCell,
    },
  ];

  return (
    <Table
      className="-striped -highlight"
      columns={columns}
      data={data}
      totalRecords={totalProspects}
      addOnOpen={addOnOpen}
      onBulkOpen={onBulkOpen}
    />
  );
}

export default ProspectTable;
